import { createSlice } from "@reduxjs/toolkit";

const contactUsSlice = createSlice({
  name: "ContactInfos",
  initialState: {
    contactInfo: {
      data: [],
      loading: false,
      error: null,
    },
  },
  reducers: {
    fetchcontactInfoStart(state) {
      state.contactInfo.loading = true;
      state.contactInfo.error = null;
    },
    fetchcontactInfoSuccess(state, action) {
      state.contactInfo.loading = false;
      state.contactInfo.data = action.payload;
    },
    fetchcontactInfoFailure(state, action) {
      state.contactInfo.loading = false;
      state.contactInfo.error = action.payload;
    },
    updatecontactInfoStart(state) {
      state.contactInfo.loading = true;
      state.contactInfo.error = null;
    },
    updatecontactInfoSuccess(state, action) {
      state.contactInfo.loading = false;
      state.contactInfo.data = action.payload;
    },
    updatecontactInfoFailure(state, action) {
      state.contactInfo.loading = false;
      state.contactInfo.error = action.payload;
    },
    getInquiryStart(state) {
      state.contactInfo.loading = true;
      state.contactInfo.error = null;
    },
    getInquirySuccess(state, action) {
      state.contactInfo.loading = false;
      state.contactInfo.data = action.payload;
    },
    getInquiryFailure(state, action) {
      state.contactInfo.loading = false;
      state.contactInfo.error = action.payload;
    },
  },
});
export const {
  fetchcontactInfoStart,
  fetchcontactInfoSuccess,
  fetchcontactInfoFailure,
  updatecontactInfoStart,
  updatecontactInfoSuccess,
  updatecontactInfoFailure,
  getInquiryStart,
  getInquirySuccess,
  getInquiryFailure
} = contactUsSlice.actions;

export default contactUsSlice.reducer;
